import { ReviewStayModel } from "../../../interfaces/models/reviewStayModel";
import { ListingInterface } from "../viewListing";
import {
    ViewListingReviewWrapper,
    ViewListingReviewBox,
    ViewListingReviewTitle,
    ViewListingReviewContentTitle,
    ViewListingReviewContentHeader,
    ViewListingReviewContentSubtitle,
    ViewListingSectionWrapper,
    ViewListingNoServiceFeeTitleWrapper,
    ViewListingNoServiceFeeTitle,
    ViewListingNoServiceFeeSubtitle,
    ViewListingNoServiceFeeIconWrapper,
    ViewListingNoServiceFeeIcon,
    ViewListingSectionHostIconWrapper,
} from "../viewListingStyling";

interface ViewListingReviewPreviewProps {
    listing: ListingInterface;
    reviews: ReviewStayModel[];
}

export default function ViewListingReviewPreview({ listing, reviews }: ViewListingReviewPreviewProps) {
    const reviewContent = reviews.find((e) => e.body !== "");
    return (
        <ViewListingReviewWrapper>
            <ViewListingSectionWrapper>
                <ViewListingReviewBox>
                    <ViewListingReviewTitle reviews={reviews}>{reviews.length !== 0 ? ((listing.overallAverage / 10) * 2).toFixed(1) : "NEW"}</ViewListingReviewTitle>
                </ViewListingReviewBox>
                <ViewListingReviewContentHeader>
                    <ViewListingReviewContentTitle>
                        {reviews.length > 0 ? (reviews.length > 1 ? `Rated by ${reviews.length} reviews` : `Rated by ${reviews.length} review`) : "Be the first to review this place"}
                    </ViewListingReviewContentTitle>
                    <ViewListingReviewContentSubtitle>
                        {reviews.length > 0 ? (reviewContent ? reviewContent.body : "The user did not leave a review") : "Get 10% off your first stay with the code HELLOAUS"}
                    </ViewListingReviewContentSubtitle>
                </ViewListingReviewContentHeader>
            </ViewListingSectionWrapper>
            <ViewListingSectionWrapper>
                <ViewListingNoServiceFeeIconWrapper>
                    <ViewListingNoServiceFeeIcon src="https://d292awxalydr86.cloudfront.net/Listing+page+icons/highlight1.jpg" alt="No Service Fee Icon" />
                </ViewListingNoServiceFeeIconWrapper>
                <ViewListingNoServiceFeeTitleWrapper>
                    <ViewListingNoServiceFeeTitle>10% off stays over 28 nights</ViewListingNoServiceFeeTitle>
                    <ViewListingNoServiceFeeSubtitle>Your host offers a long stay discount over 28 nights.</ViewListingNoServiceFeeSubtitle>
                </ViewListingNoServiceFeeTitleWrapper>
            </ViewListingSectionWrapper>
            <ViewListingSectionWrapper>
                <ViewListingNoServiceFeeIconWrapper>
                    <ViewListingNoServiceFeeIcon src="https://d292awxalydr86.cloudfront.net/Listing+page+icons/highlight2.jpg" alt="No Service Fee Icon" />
                </ViewListingNoServiceFeeIconWrapper>
                <ViewListingNoServiceFeeTitleWrapper>
                    <ViewListingNoServiceFeeTitle>This place has been verified</ViewListingNoServiceFeeTitle>
                    <ViewListingNoServiceFeeSubtitle>We have verified the accuracy of this listing.</ViewListingNoServiceFeeSubtitle>
                </ViewListingNoServiceFeeTitleWrapper>
            </ViewListingSectionWrapper>
            {/* <ViewListingSectionWrapper>
                <ViewListingSectionHostIconWrapper>
                    <ViewListingNoServiceFeeIcon src="https://d292awxalydr86.cloudfront.net/Listing+page+icons/highlight3.jpg" alt="No Service Fee Icon" />
                </ViewListingSectionHostIconWrapper>
                <ViewListingNoServiceFeeTitleWrapper>
                    <ViewListingNoServiceFeeTitle>Hosted by Eve</ViewListingNoServiceFeeTitle>
                    <ViewListingNoServiceFeeSubtitle>Hosting since 2024.</ViewListingNoServiceFeeSubtitle>
                </ViewListingNoServiceFeeTitleWrapper>
            </ViewListingSectionWrapper> */}
        </ViewListingReviewWrapper>
    );
}
